import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellBody extends PureComponent {
  render() {
    const { children, className, flex, ...others } = this.props;
    const cls = classNames({
      "weui-cell__bd": true,
      "weui-flex": flex
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
